import styled, { css } from 'styled-components'

import { Text } from 'mf-ui-components'

import { spacing } from '../../../../utils/ui/spacing'
import { LightCarouselSettings } from './types'
import { serifFont } from '../../../../utils/style/serifFont'
import { fromBreakpoint } from '../../../../utils/style/breakpoint'

export const CarouselItemContainer = styled.article`
  width: 100%;
  flex: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  text-align: center;
  padding: ${spacing('xs')} ${spacing('xl')};

  ${fromBreakpoint('md')} {
    padding: ${spacing('xs')} ${spacing('4xl')} ${spacing('xl')}
      ${spacing('4xl')};
  }
`

export const Image = styled.img<Pick<LightCarouselSettings, 'imageShape'>>`
  border-radius: ${({ imageShape }) =>
    imageShape === 'circle'
      ? '50%'
      : imageShape === 'rounded'
      ? '16px'
      : '0px'};
  width: 60%;
  aspect-ratio: 1/1;
  overflow: hidden;
  margin-bottom: ${spacing('xl')};
  object-fit: cover;
  flex: none;

  ${fromBreakpoint('sm')} {
    width: 32%;
  }

  ${fromBreakpoint('lg')} {
    width: 20%;
  }

  ${fromBreakpoint('xl')} {
    min-width: 140px;
    width: 16%;
  }

  ${fromBreakpoint('xxl')} {
    min-width: 160px;
    width: 12%;
  }
`

export const Title = styled(Text).attrs({
  styleName: 'title4',
  el: 'h1',
})`
  margin-bottom: ${spacing('lg')};
  text-align: center;
  ${({ theme }) => (theme.id === 'mf-2023-light' ? serifFont : '')}
`

export const Description = styled(Text).attrs({
  styleName: 'bodyRegular',
})`
  text-align: center;
`
